import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EditIcon extends BaseIcon {
  getChildren = () => [<path
    fill={ this.getColor() }
    d='M3,11v2H5l7-7L10,4Zm9-9L11,3l2,2,1-1Z'/>]
  getViewBox = () => '0 0 16 16'
}
